import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, maxChars: number = 20): string {
    if (!value) return '';
    return value.length > maxChars ? value.slice(0, maxChars) + '...' : value;
  }
}
